import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";
import Logo from "../assets/login.png";
import Image from "../assets/image.jpeg";
import { login } from "../api/api";
import { toast } from "react-toastify";

function Login() {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const loginUser = async (e) => {
    e.preventDefault();

    if (!form.email || !form.password) {
      toast.error("Please enter both email and password.");
      return;
    }

    try {
      const response = await login(form);
      if (response.data) {
        const data = response.data;
        toast.success("Successfully logged in");
        localStorage.setItem("user", JSON.stringify(data.user));
        authContext.signin(data.token, () => navigate("/"));
      } else {
        toast.error("Wrong credentials. Please try again.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-screen bg-gray-100">
      {/* Left Section: Image */}
      <div className="hidden lg:flex justify-center items-center bg-blue-50">
        <img
          src={Image}
          alt="Construction Scene"
          className="object-cover max-h-full w-full"
        />
      </div>

      {/* Right Section: Login Form */}
      <div className="flex flex-col justify-center items-center w-full px-6 py-8 sm:px-10">
        <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg animate-fadeIn transition duration-500 ease-in-out">
          <div className="text-center mb-6">
            <img src={Logo} alt="Your Company" className="mx-auto h-14 w-auto" />
            <h2 className="mt-4 text-2xl sm:text-3xl font-extrabold text-gray-800">
              Welcome Back!
            </h2>
            <p className="text-sm sm:text-base text-gray-500 mt-2">
              Log in to access project resources and tools
            </p>
          </div>

          <form className="space-y-6" onSubmit={loginUser}>
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="block w-full rounded-t-md border border-gray-300 px-4 py-2 sm:py-3 text-gray-900 placeholder-gray-500 focus:border-blue-600 focus:ring-blue-600 transition"
                placeholder="Email address"
                value={form.email}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="block w-full rounded-b-md border border-gray-300 px-4 py-2 sm:py-3 text-gray-900 placeholder-gray-500 focus:border-blue-600 focus:ring-blue-600 transition"
                placeholder="Password"
                value={form.password}
                onChange={handleInputChange}
              />
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 text-sm text-gray-800"
                >
                  Remember me
                </label>
              </div>

              <div className="text-sm">
                <a
                  href="#"
                  className="font-medium text-blue-600 hover:text-blue-500"
                >
                  Forgot password?
                </a>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center py-2 px-4 sm:py-3 border border-transparent text-sm sm:text-base font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-blue-400 hover:from-blue-500 hover:to-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-transform duration-300 hover:scale-105"
              >
                Sign In
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
